import { QueryClient } from '@tanstack/react-query';

/**
 * Shared application query client, kept outside App to avoid auth cycles.
 * Data is fresh for 30 seconds and garbage-collected after five minutes;
 * authenticated data is cleared explicitly at every account boundary.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      gcTime: 1000 * 60 * 5,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error && typeof error === 'object' && 'response' in error) {
          const status = (error as { response?: { status?: number } }).response?.status;
          if (status && status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 2;
      },
    },
  },
});
